import React from 'react';
import { Field, useFormikContext } from 'formik';
import { Box, FormControl, FormLabel, Input, FormErrorMessage } from '@chakra-ui/react';

const Kaleyra = ({ formikProps,setProviderData }) => {
  const { handleChange, errors, touched } = useFormikContext();

  return (
    <Box p={4} borderWidth={1} borderRadius="lg" boxShadow="lg">
      <FormControl id="wabaId" mb={4} isInvalid={errors.wabaId && touched.wabaId}>
        <FormLabel>WABA ID</FormLabel>
        <Field name="wabaId" as={Input} placeholder="WABA ID" onChange={(e) => {
          handleChange(e);
          setProviderData((prev) => ({ ...prev, wabaId: e.target.value }));
        }} />
        <FormErrorMessage>{errors.wabaId}</FormErrorMessage>
      </FormControl>

      <FormControl id="account" mb={4} isInvalid={errors.account && touched.account}>
        <FormLabel>SID</FormLabel>
        <Field name="account" as={Input} placeholder="SID" onChange={(e) => {
          handleChange(e);
          setProviderData((prev) => ({ ...prev, account: e.target.value }));
        }} />
        <FormErrorMessage>{errors.account}</FormErrorMessage>
      </FormControl>

      <FormControl id="auth" mb={4} isInvalid={errors.auth && touched.auth}>
        <FormLabel>API Key</FormLabel>
        <Field name="auth" as={Input} placeholder="API Key" onChange={(e) => {
          handleChange(e);
          setProviderData((prev) => ({ ...prev, auth: e.target.value }));
        }} />
        <FormErrorMessage>{errors.auth}</FormErrorMessage>
      </FormControl>
    </Box>
  );
};

export default Kaleyra;
